import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  public showBreadcrumb = new EventEmitter();
  public clearBreadcrumb = new EventEmitter();
  constructor() { }
}
